const TimelineStep = ({ estado, actual }) => {
    const estados = {
      'cotizacion_solicitada': { text: 'Solicitud Creada', order: 1 },
      'documentos_en_revision': { text: 'Tramite en Revisión', order: 2 },
      'en_proceso': { text: 'Proceso de Pago', order: 3 },
      'completado': { text: 'Completado', order: 4 }
    };
  
    const estadoActualOrder = estados[actual]?.order || 0;
    const stepOrder = estados[estado]?.order || 0;
  
    const isActive = stepOrder <= estadoActualOrder;
    const isCurrent = estado === actual;
  
    return (
      <div className={`flex items-center space-x-3 p-2 rounded-lg ${isCurrent ? 'bg-blue-100' : isActive ? 'bg-green-50' : 'bg-gray-100'
        }`}>
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${isCurrent ? 'bg-blue-600 text-white' :
          isActive ? 'bg-green-600 text-white' :
            'bg-gray-300 text-gray-600'
          }`}>
          {stepOrder}
        </div>
        <span className={`text-sm font-medium ${isCurrent ? 'text-blue-800' :
          isActive ? 'text-green-800' :
            'text-gray-600'
          }`}>
          {estados[estado]?.text}
        </span>
      </div>
    );
  };

export default TimelineStep;